/* eslint-disable @typescript-eslint/naming-convention */

import { ReactElement, ReactNode } from 'react';
import { CSSProperties } from 'styled-components';
import { GeneralFunction } from 'types/common';

/* eslint-disable import/prefer-default-export */
export enum INPUT_TYPE {
  TEXT = 'text',
  NUMBER = 'number',
  PASSWORD = 'password',
  SELECT = 'select',
  TEXT_AREA = 'textarea',
  FILE = 'file',
  CHECKBOX_GROUP = 'checkbox_group',
  EMAIL = 'email',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  DATE_PICKER = 'date',
  TIME_PICKER = 'time_picker',
  RANGE_PICKER = 'range_picker',
  SWITCH = 'switch',
  AVATAR = 'avatar',
  TEXT_ONLY = 'text_only',
}

export enum LABEL_TYPE {
  inside = 'inside',
  left = 'left',
  right = 'right',
  above = 'above',
  under = 'under',
}

export interface ICommonBothTypeLabelProps {
  className?: string;
  label?: string | ReactElement;
  labelType?: LABEL_TYPE;
  extra?: ReactNode;
  onChange?: GeneralFunction;
  disabled?: boolean;
  placeholder?: string;
  options?: any;
  labelStyle?: CSSProperties;
  inputOptions?: any;
}

export interface ICommonBothTypeInputProps extends ICommonBothTypeLabelProps {
  name: string;
  type: INPUT_TYPE;
  containerStyle?: CSSProperties;
  responsiveLabel?: boolean;
}

export interface IOptionFields {
  value: string;
  label: string;
}
